
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.254 5.999a.743.743 0 01-.53-.22l-3-3c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53c.141-.142.33-.22.53-.22s.389.078.53.22l3 3c.142.141.22.33.22.53s-.078.389-.22.53a.743.743 0 01-.53.22zM5.254 8.999a.75.75 0 010-1.5h1.5a.75.75 0 010 1.5h-1.5zM11.254 4.499a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5a.75.75 0 01-.75.75zM14.254 16.499a.75.75 0 010-1.5h4.5a3.754 3.754 0 003.75-3.75 3.754 3.754 0 00-3.75-3.75h-4.5a.75.75 0 010-1.5h4.5a5.256 5.256 0 015.25 5.25 5.256 5.256 0 01-5.25 5.25h-4.5zM5.254 22.499a5.213 5.213 0 01-3.712-1.538 5.256 5.256 0 010-7.425l2.652-2.652a.744.744 0 011.06 0 .744.744 0 010 1.06l-2.652 2.652a3.754 3.754 0 000 5.303c.708.708 1.65 1.098 2.652 1.098s1.943-.39 2.652-1.098l2.652-2.652a.744.744 0 011.06 0 .752.752 0 010 1.061L8.966 20.96a5.21 5.21 0 01-3.712 1.539z"}})])
          )
        }
      }
    